module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Åldersintervall")]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Från")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Till")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.saveRanges
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")])])])])]), (_vm.age_ranges) ? _c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.tr",
      value: (_vm.reorderRanges),
      expression: "reorderRanges",
      modifiers: {
        "tr": true
      }
    }]
  }, _vm._l((_vm.age_ranges.value), function(interval, idx) {
    return _c('tr', {
      key: idx,
      attrs: {
        "data-id": idx
      }
    }, [_vm._m(0, true, false), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (interval[0]),
        expression: "interval[0]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (interval[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(interval, 0, $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (interval[1]),
        expression: "interval[1]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (interval[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(interval, 1, $event.target.value)
        }
      }
    })]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteRange(idx)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])])
  })) : _vm._e(), _c('tfoot', [_c('tr', [_c('td'), _c('td'), _c('td'), _c('td', [_c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.addRange
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128e5165","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administration/Statistics.vue
// module id = 504
// module chunks = 1